export const ar = {
  appName: 'بن غانم للمواشي',
  search: 'بحث عن خروف...',
  allBreeds: 'كل الأنواع',
  allGenders: 'الكل',
  male: 'ذكر',
  female: 'أنثى',
  sortNewest: 'الأحدث',
  sortPriceAsc: 'السعر: الأقل',
  sortPriceDesc: 'السعر: الأعلى',
  newBadge: 'جديد',
  addToCart: 'أضف للسلة',
  buyNow: 'اشتري الآن',
  share: 'مشاركة',
  whatsapp: 'واتساب',
  cartEmpty: 'السلة فارغة',
  cartEmptyDesc: 'أضف أغنام للسلة للمتابعة',
  cart: 'السلة',
  total: 'المجموع',
  checkout: 'إتمام الشراء',
  continueShopping: 'متابعة التسوق',
  remove: 'حذف',
  orderDetails: 'تفاصيل الطلب',
  customerName: 'الاسم الكامل',
  customerPhone: 'رقم الهاتف',
  country: 'الدولة',
  city: 'المدينة',
  address: 'العنوان',
  notes: 'ملاحظات (اختياري)',
  placeOrder: 'تأكيد الطلب',
  orderSuccess: 'تم استلام طلبك!',
  orderSuccessDesc: 'سيتواصل معك فريقنا قريباً لتأكيد الطلب.',
  orderNumber: 'رقم الطلب',
  trackOrder: 'تتبع طلبي',
  myOrders: 'طلباتي',
  home: 'الرئيسية',
  contact: 'تواصل',
  account: 'حسابي',
  contactUs: 'تواصل معنا عبر واتساب',
  sheepDetails: 'تفاصيل الخروف',
  breed: 'النوع',
  gender: 'الجنس',
  age: 'العمر',
  price: 'السعر',
  description: 'الوصف',
  availableText: 'متاح',
  notAvailable: 'غير متاح',
  loadMore: 'تحميل المزيد',
  noSheepFound: 'لا توجد أغنام متاحة',
  noSheepDesc: 'جرّب تغيير معايير البحث',
  buyingNotAvailable: 'الشراء غير متاح في دولتك حالياً',
  contactForOrder: 'تواصل معنا عبر واتساب للطلب',
  enterPhoneToTrack: 'أدخل رقم هاتفك لعرض طلباتك',
  phoneNumber: 'رقم الهاتف',
  search_orders: 'بحث',
  noOrders: 'لا توجد طلبات',
  orderStatus: {
    pending: 'قيد المراجعة',
    confirmed: 'مؤكد',
    processing: 'جاري التجهيز',
    shipped: 'تم الشحن',
    delivered: 'تم التسليم',
    cancelled: 'ملغى',
  },
  months: 'شهر',
  years: 'سنة',
  days: 'يوم',
  required: 'مطلوب',
  selectCountry: 'اختر دولتك',
  inCart: 'في السلة',
  alreadyInCart: 'موجود في السلة',
  itemsInCart: 'عناصر في السلة',
};

export const en = {
  appName: 'Bin Ghanim Livestock',
  search: 'Search sheep...',
  allBreeds: 'All Breeds',
  allGenders: 'All',
  male: 'Male',
  female: 'Female',
  sortNewest: 'Newest',
  sortPriceAsc: 'Price: Low to High',
  sortPriceDesc: 'Price: High to Low',
  newBadge: 'New',
  addToCart: 'Add to Cart',
  buyNow: 'Buy Now',
  share: 'Share',
  whatsapp: 'WhatsApp',
  cartEmpty: 'Your cart is empty',
  cartEmptyDesc: 'Add sheep to your cart to proceed',
  cart: 'Cart',
  total: 'Total',
  checkout: 'Checkout',
  continueShopping: 'Continue Shopping',
  remove: 'Remove',
  orderDetails: 'Order Details',
  customerName: 'Full Name',
  customerPhone: 'Phone Number',
  country: 'Country',
  city: 'City',
  address: 'Address',
  notes: 'Notes (optional)',
  placeOrder: 'Place Order',
  orderSuccess: 'Order Received!',
  orderSuccessDesc: 'Our team will contact you soon to confirm your order.',
  orderNumber: 'Order Number',
  trackOrder: 'Track My Order',
  myOrders: 'My Orders',
  home: 'Home',
  contact: 'Contact',
  account: 'Account',
  contactUs: 'Contact us on WhatsApp',
  sheepDetails: 'Sheep Details',
  breed: 'Breed',
  gender: 'Gender',
  age: 'Age',
  price: 'Price',
  description: 'Description',
  availableText: 'Available',
  notAvailable: 'Not Available',
  loadMore: 'Load More',
  noSheepFound: 'No sheep found',
  noSheepDesc: 'Try changing your search filters',
  buyingNotAvailable: 'Online buying is not available in your country',
  contactForOrder: 'Contact us on WhatsApp to order',
  enterPhoneToTrack: 'Enter your phone number to view your orders',
  phoneNumber: 'Phone Number',
  search_orders: 'Search',
  noOrders: 'No orders found',
  orderStatus: {
    pending: 'Pending',
    confirmed: 'Confirmed',
    processing: 'Processing',
    shipped: 'Shipped',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
  },
  months: 'months',
  years: 'years',
  days: 'days',
  required: 'Required',
  selectCountry: 'Select your country',
  inCart: 'In Cart',
  alreadyInCart: 'Already in Cart',
  itemsInCart: 'items in cart',
};
